import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Box, Avatar, Card, CardContent, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { format } from 'date-fns';
import { usePlagues } from '@graniot/common/adapters/plagues';
import Plague from './Plague';
import warning from '../../../assets/warning.png';
import green_warning from '../../../assets/green-warning.png';
import orange_warning from '../../../assets/orange-warning.png';
import yellow_warning from '../../../assets/yellow-warning.png';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: 10,
  },
  root: {
    width: '100%',
    margin: 2.5,
  },
}));

function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export default function PlaguesList({ parcel }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [toDate, setToDate] = React.useState(format(addDays(new Date(), 7), 'yyyy-MM-dd'));
  const { data, refetch, isLoading } = usePlagues(parcel.id);

  React.useEffect(() => {
    if (toDate)
      refetch();
  }, [toDate]);

  return (
    <Grid container
      spacing={2}
      alignItems="flex-start"
      direction='row'
      className={classes.root}
    >
      <Grid item xs={3}>
        <Card className={classes.root} elevation={3}>
          <CardContent>
            {<h2 style={{ color: "dimGrey", margin: 0 }}>{t("Plagues.caption")}</h2>}
            <List>
              <ListItem>
                  <Avatar aria-label="recipe"
                    style={{ color: 'white', height: 'auto', width: '25px', margin: 10 }}
                    src={green_warning}>
                  </Avatar>
                <ListItemText secondary={t("Plagues.captionGreen")} />
              </ListItem>
              <ListItem>
                  <Avatar aria-label="recipe"
                    style={{ color: 'white', height: 'auto', width: '25px', margin: 10 }}
                    src={yellow_warning}>
                  </Avatar>
                <ListItemText secondary={t("Plagues.captionYellow")} />
              </ListItem>
              <ListItem>
                  <Avatar aria-label="recipe"
                    style={{ color: 'white', height: 'auto', width: '25px', margin: 10 }}
                    src={orange_warning}>
                  </Avatar>
                <ListItemText secondary={t("Plagues.captionOrange")} />
              </ListItem>
              <ListItem>
                  <Avatar aria-label="recipe"
                    style={{ color: 'white', height: 'auto', width: '25px', margin: 10 }}
                    src={warning}>
                  </Avatar>
                <ListItemText secondary={t("Plagues.captionRed")} />
              </ListItem>
            </List>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={9}>
        <List style={{ padding: 0 }}>
          {
            data ? (data.length !== 0 ? data.map((plague, index) => (
              <ListItem key={index}>
                <Plague plague={plague} parcel={parcel} />
              </ListItem>
            )) :
            <h1 style={{ color: "dimGrey", margin: 0 }}>{t("Plagues.any")}</h1>) :
            null
          }
        </List>
      </Grid>
    </Grid>
  );
}
